<template>
  <div id="placeInfo" v-cloak>
    <!-- Logo -->
    <div class="LogoBorder">
      <img :src="logoUrl" alt="">
      <div>|</div>
      <div>弘成慧考平台</div>
    </div>
    <!-- Info -->
    <div class="Main">
      <div class="userName list">
        <span class="label">学生姓名</span>
        <span class="label">：</span>
        <p class="text">{{Info.realName}}</p>
      </div>
      <div class="entranceCode list">
        <span class="label">证件号</span>
        <span class="label">：</span>
        <p class="text">{{Info.cardNo}}</p>
      </div>
      <div class="placeName list">
        <span class="label">性别</span>
        <span class="label">：</span>
        <span class="text">{{Info.sex}}</span>
      </div>

    </div>

    <div class="Main" style="margin-top: 24px;">
      <div class="userName list">
        <span class="label">成绩</span>
        <span class="label">：</span>
        <p class="text">{{Info.score}}</p>
      </div>
      <div class="entranceCode list">
        <span class="label">考试状态</span>
        <span class="label">：</span>
        <p class="text">{{Info.examStatus}}</p>
      </div>
      <div class="placeName list">
        <span class="label">考试科目</span>
        <span class="label">：</span>
        <span class="text">{{Info.courseName}}</span>
      </div>
      <div class="placeName list">
        <span class="label">考试批次</span>
        <span class="label">：</span>
        <span class="text">{{Info.planName}}</span>
      </div>

    </div>

  </div>
</template>
<script>
  export default {
    data() {
      return {
        logoUrl: "",
        Info: [],
      }
    },
    created() {
      this.getInfo()
    },
    methods: {
      getInfo() {
        const { tenant, id } = this.$route.query
        this.$api.system.getSystemNameFN({ tenant }).then(res=>{
          this.logoUrl = res.data.isUsedLogo == 1 ? res.data.logoUrl ? res.data.logoUrl : require("@/assets/img/customDefault.png") : require("@/assets/img/customDefault.png")
        })
        this.$api.system.getCertificateInfo({tenant, id}).then(res=>{
          this.Info = res.data
        })

      },
      
    },

  }
</script>

<style scoped lang="less">
[v-clock] {
  display: none
}
#placeInfo {
  // font-display: block;
  width: 100%;
  height: auto;
  min-height: 100%;
  background: rgba(255, 245, 248, 1);
  background: url("../../assets/img/placeInfo_bg.png") no-repeat;
  background-size: 100% 3.2rem;
  padding: 0 .38rem;
  overflow: hidden;
  box-sizing: border-box;
  .LogoBorder {
    width: 100%;
    height: 1.5rem;
    padding-top: .5rem;
    box-sizing: border-box;
    display: flex;
    margin-bottom: 0.32rem;
    &>img {
      width: auto;
      height: .8rem;
    }
    &>div {
      color: #FFF;
      line-height: .8rem;
      margin: 0 .2rem;
      font-size: .48rem;
      font-display: optional;
      font-family: 'PingFangSC-Regular, PingFang SC';
      font-weight: 500;
    }
    &>div:first-of-type {
      color: rgba(255, 255, 255, 0.3);
    }
  }
  .Main {
    width: 100%;
    background: #FFF;
    border-radius: .2rem;
    padding-top: .5rem;
    font-display: optional;
    font-family: 'PingFangSC-Regular, PingFang SC';
    font-display: block;
    box-shadow: #737780 0 0 .1rem;
    font-size: .38rem;
    .list {
      padding: 0 .4rem;
      box-sizing: border-box;
      padding-bottom: .4rem;
      display: flex;
      .label:first-child {
        color: #737780;
        display: inline-block;
        width: 1.6rem;
        line-height: .5rem;
        text-align: justify;
        text-align-last: justify;
        font-size: .38rem;
      }
      .text {
        word-wrap: break-word;
        word-break: break-all;
        display: inline-block;
        color: #2D2F33;
        line-height: .5rem;
        max-width: 6.5rem;
        height: auto;
      }
      .copy,.address {
        width: 0.64rem;
        height: 0.64rem;
        box-sizing: border-box;
      }
      .copy {
        background:url("../../assets/img/placeInfo_copy.png") no-repeat;
        background-size: 100% 100%;
        margin-right: .15rem;
      }
      .address {
        background:url("../../assets/img/placeInfo_addredd.png") no-repeat;
        background-size: 100% 100%;
      }
    }
    .placeAddress {
      .text {
        width: 4.8rem;
      }
      .copy {
        margin-left: .2rem;
      }
    }
    .placeLine {
      .text {
        width: 5.8rem;
      }
      .copy {
        margin: 0;
      }
    }

  }
}
</style>